module.exports = __webpack_public_path__ + "img/bannerDebug.babec592.jpg";